import React, { Component } from 'react'

import { Container } from './styledComponents'
import PlaceToPlayIbcricket from './PlaceToPlayIbcricket'

export default class PlacesListToPlayIbcricket extends Component {
  renderList = () => {
    const { placesList } = this.props
    return placesList.map(item => <PlaceToPlayIbcricket item={item} />)
  }

  render() {
    return <Container>{this.renderList()}</Container>
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PlacesToPlayIbcricket/PlacesListToPlayIbcricket/index.js